import AllSponsors from './AllSponsors';
export default AllSponsors;